import React from 'react';
import { SectionCTA } from './SectionCTA';
export function ProblemSolution() {
  return <section id="problem-solution" className="bg-brand-lightMint py-20 px-4 sm:px-6 lg:px-8" data-id="element-120">
      <div className="max-w-3xl mx-auto text-center" data-id="element-121">
        <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-8 leading-tight" data-id="element-122">
          Leer hoe jouw hond écht met je communiceert{' '}
          <span className="text-brand-mint" data-id="element-123">(vanuit zijn natuur)</span>
        </h2>

        <div className="bg-white rounded-3xl p-8 sm:p-10 shadow-sm border border-teal-50 text-left" data-id="element-124">
          <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-125">
            De meeste hondenbaasjes voelen zich soms gefrustreerd of onzeker
            omdat ze niet precies weten wat hun hond probeert te vertellen.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-126">
            In dit webinar leg ik je uit hoe honden met hun lichaam, houding en
            blik vertellen wat ze denken en voelen. Zodra je dit gaat zien, zul
            je jouw hond vele malen beter begrijpen.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed font-medium text-slate-800 bg-teal-50/50 p-4 rounded-2xl border border-teal-100" data-id="element-127">
            Ook leer je hoe jij als mens terug kan "praten", zodat jouw hond
            voortaan precies weet wat je bedoelt.
          </p>
        </div>

        <SectionCTA data-id="element-128" />
      </div>
    </section>;
}